// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Status Icon Styles */
.AIAgentBot_statusIcon__39565 {
  margin-left: 8px;
  font-size: 16px;
  flex-shrink: 0;
}

.AIAgentBot_statusLoading__WAmmt {
  color: #f59e0b;
  animation: AIAgentBot_spin__CjsFu 1s linear infinite;
}

.AIAgentBot_statusSuccess__4D6mB {
  color: #10b981;
}

.AIAgentBot_statusFailed__dB3cC {
  color: #ef4444;
}

@keyframes AIAgentBot_spin__CjsFu {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* URL Input with Status */
.AIAgentBot_urlInputWithStatus__Po-cU {
  flex: 1 1;
  min-width: 200px;
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
}

.AIAgentBot_urlInput__W44tc {
  flex: 1 1;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.AIAgentBot_urlInput__W44tc:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
}

/* File Info with Status */
.AIAgentBot_fileInfo__YwU\\+Q {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1;
}

.AIAgentBot_fileName__2ePaP {
  font-weight: 500;
  color: #333;
}

.AIAgentBot_dataIds__f0lTY {
  font-size: 0.8rem;
  color: #666;
  margin-left: 4px;
}

/* File Item */
.AIAgentBot_fileItem__1jOFw {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  margin-bottom: 5px;
  flex-wrap: wrap;
  gap: 8px;
}

.AIAgentBot_fileOptions__1K63- {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

/* Training Ready State */
.AIAgentBot_trainingReady__kCxUO {
  color: #0c5460;
  background-color: #d1ecf1;
  border: 1px solid #bee5eb;
  border-radius: 4px;
  padding: 8px 12px;
  margin-top: 10px;
  font-size: 0.9rem;
}

/* Info Tooltip Styles */
.AIAgentBot_infoTooltipWrapper__XnIH8 {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
  cursor: help;
}

.AIAgentBot_infoIcon__nvrRF {
  color: #6c757d;
  font-size: 14px;
  transition: color 0.2s ease;
}

.AIAgentBot_infoIcon__nvrRF:hover {
  color: #007bff;
}

.AIAgentBot_infoTooltip__mJxca {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background: #1f2937;
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
  max-width: 300px;
  white-space: normal;
  word-wrap: break-word;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  text-align: left;
  line-height: 1.4;
}

.AIAgentBot_infoTooltip__mJxca::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-top-color: #1f2937;
}

/* URL Section Layout Improvements */
.AIAgentBot_crawlingOptionsSection__o5FFb {
  margin-bottom: 16px;
  padding: 12px 16px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.AIAgentBot_crawlingOptionsTitle__rX5wt {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #495057;
}

.AIAgentBot_crawlingOptionsGrid__2WLvT {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.AIAgentBot_allowNestedSection__rQxnU {
  padding: 8px 0;
}

.AIAgentBot_allowNestedLabel__T5xmY {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 0;
}

.AIAgentBot_allowNestedText__2oqg3 {
  font-size: 14px;
  color: #495057;
}

.AIAgentBot_globalExploreClickablesSection__yJ7qM {
  padding: 8px 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.AIAgentBot_globalExploreClickablesLabel__Y0UdC {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 0;
}

.AIAgentBot_globalExploreClickablesText__z6wOw {
  font-size: 14px;
  color: #495057;
  font-weight: 500;
}

.AIAgentBot_exploreClickablesHint__z2NmO {
  margin-top: 6px;
  padding: 6px 10px;
  background: #e7f3ff;
  border-radius: 4px;
  font-size: 12px;
  color: #0066cc;
  border-left: 3px solid #007bff;
}

/* URL Input Row Improvements */
.AIAgentBot_urlInputRow__qGbnP {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
}

.AIAgentBot_urlInputWithStatus__Po-cU {
  flex: 1 1;
  min-width: 200px;
  position: relative;
}

.AIAgentBot_urlInput__W44tc {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.AIAgentBot_urlInput__W44tc:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
}

/* Per URL Explore Clickables */
.AIAgentBot_perUrlExploreCheckbox__nM1b- {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.AIAgentBot_perUrlExploreLabel__JMjK7 {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  font-size: 13px;
  color: #495057;
}

.AIAgentBot_perUrlExploreText__nfbO7 {
  font-size: 13px;
  color: #495057;
}

/* Force Reingest and Force Delete */
.AIAgentBot_forceReingestCheckbox__8IprL,
.AIAgentBot_forceDeleteCheckbox__WH7Ll {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.AIAgentBot_forceReingestLabel__94y3q,
.AIAgentBot_forceDeleteLabel__MGknf {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  font-size: 13px;
  color: #495057;
}

.AIAgentBot_forceReingestText__L54JQ,
.AIAgentBot_forceDeleteText__dtE9X {
  font-size: 13px;
  color: #495057;
}

/* Responsive adjustments */
@media (max-width: 1200px) {
  .AIAgentBot_urlInputRow__qGbnP {
    flex-wrap: wrap;
  }

  .AIAgentBot_urlInputWithStatus__Po-cU {
    min-width: 100%;
    flex-basis: 100%;
  }

  .AIAgentBot_perUrlExploreCheckbox__nM1b-,
  .AIAgentBot_forceReingestCheckbox__8IprL,
  .AIAgentBot_forceDeleteCheckbox__WH7Ll {
    flex-shrink: 1;
  }
}

@media (max-width: 768px) {
  .AIAgentBot_urlInputRow__qGbnP {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .AIAgentBot_perUrlExploreCheckbox__nM1b-,
  .AIAgentBot_forceReingestCheckbox__8IprL,
  .AIAgentBot_forceDeleteCheckbox__WH7Ll {
    margin-left: 0;
  }
}

/* Add to AIAgentBot.module.css */
.AIAgentBot_limitsDropdownSection__UKOdT {
  margin-bottom: 10px;
}

.AIAgentBot_limitsDropdownHeader__UkevF {
  cursor: pointer;
  transition: all 0.3s ease;
}

.AIAgentBot_limitsDropdownHeader__UkevF:hover {
  background-color: #e9ecef !important;
}

.AIAgentBot_limitsDropdownContent__ZaN3T {
  animation: AIAgentBot_slideDown__E\\+Z8g 0.3s ease;
}

@keyframes AIAgentBot_slideDown__E\\+Z8g {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Main credit section styling */
.AIAgentBot_creditSection__uqCsH {
  background: white;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease;
}

.AIAgentBot_creditSection__uqCsH:hover {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.AIAgentBot_creditSection__uqCsH h3 {
  margin: 0 0 20px 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
}

.AIAgentBot_creditsContainer__8z2E\\+ {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.AIAgentBot_creditsMain__rA-XT {
  text-align: center;
  padding: 16px;
  background: linear-gradient(135deg, #f3f4f6 0%, #ffffff 100%);
  border-radius: 12px;
}

.AIAgentBot_creditsRemaining__NZtUn {
  font-size: 3rem;
  font-weight: bold;
  color: #10b981;
  display: block;
  line-height: 1.2;
}

.AIAgentBot_creditsLabel__6wiEP {
  font-size: 0.875rem;
  color: #6b7280;
  display: block;
  margin-top: 8px;
}

.AIAgentBot_progressBar__l6v29 {
  width: 100%;
  height: 8px;
  background-color: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
}

.AIAgentBot_progressFill__JPIB1 {
  height: 100%;
  background: linear-gradient(90deg, #10b981, #34d399);
  border-radius: 4px;
  transition: width 0.3s ease;
}

.AIAgentBot_capacityInfo__qp1nY {
  background: #f9fafb;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.AIAgentBot_capacityRow__AsI04 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  font-size: 0.875rem;
}

.AIAgentBot_capacityRow__AsI04 span {
  color: #6b7280;
}

.AIAgentBot_capacityRow__AsI04 strong {
  color: #1f2937;
  font-weight: 600;
}

.AIAgentBot_topupHighlight__kuffv {
  color: #8b5cf6 !important;
}

.AIAgentBot_statsNote__ZVvO7 {
  background: #eff6ff;
  padding: 12px;
  border-radius: 8px;
  font-size: 0.875rem;
  color: #1e40af;
  border-left: 3px solid #3b82f6;
  line-height: 1.5;
}

.AIAgentBot_topUpSection__oEkTP {
  margin-top: 8px;
  text-align: center;
}

.AIAgentBot_topUpButton__m338V {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
}

.AIAgentBot_topUpButton__m338V:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.AIAgentBot_topUpInfo__4\\+8wB {
  margin-top: 8px;
  font-size: 0.75rem;
  color: #6b7280;
}

.AIAgentBot_lowCreditsWarning__sOJRv {
  background: #fef3c7;
  padding: 12px;
  border-radius: 8px;
  font-size: 0.875rem;
  color: #92400e;
  border-left: 3px solid #f59e0b;
}

.AIAgentBot_criticalWarning__wrYzT {
  background: #fee2e2;
  padding: 12px;
  border-radius: 8px;
  font-size: 0.875rem;
  color: #991b1b;
  border-left: 3px solid #dc2626;
}

.AIAgentBot_loadingState__cTxmX {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  gap: 12px;
}

.AIAgentBot_loadingSpinner__bMrSx {
  width: 40px;
  height: 40px;
  border: 3px solid #f3f4f6;
  border-top: 3px solid #667eea;
  border-radius: 50%;
  animation: AIAgentBot_spin__CjsFu 1s linear infinite;
}

@keyframes AIAgentBot_spin__CjsFu {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Modal Styles */
.AIAgentBot_modalOverlay__BvwY0 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.AIAgentBot_modalContent__aPgqn {
  background: white;
  border-radius: 16px;
  max-width: 600px;
  width: 90%;
  max-height: 85vh;
  overflow-y: auto;
  box-shadow:
    0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.AIAgentBot_modalHeader__Uj2Hy {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.AIAgentBot_modalHeader__Uj2Hy h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
}

.AIAgentBot_modalClose__NGFyk {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #6b7280;
  transition: color 0.2s;
}

.AIAgentBot_modalClose__NGFyk:hover {
  color: #1f2937;
}

.AIAgentBot_modalBody__Nj9Dn {
  padding: 24px;
}

.AIAgentBot_infoNote__cOpG8 {
  background: #e0e7ff;
  padding: 12px;
  border-radius: 8px;
  font-size: 0.875rem;
  color: #3730a3;
  margin-bottom: 20px;
  line-height: 1.6;
}

.AIAgentBot_topUpOptions__2aoa3 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.AIAgentBot_topUpOption__7vM1Y {
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px;
  text-align: center;
  transition: all 0.2s ease;
}

.AIAgentBot_topUpOption__7vM1Y:hover {
  border-color: #667eea;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.AIAgentBot_optionPrice__fsQM1 {
  font-size: 1.5rem;
  font-weight: bold;
  color: #1f2937;
  margin-bottom: 8px;
}

.AIAgentBot_optionMessages__OSzVM {
  font-size: 0.875rem;
  color: #6b7280;
  margin-bottom: 4px;
}

.AIAgentBot_optionPerMessage__0pUrL {
  font-size: 0.75rem;
  color: #10b981;
  margin-bottom: 12px;
}

.AIAgentBot_optionButton__p9QL3 {
  background: #667eea;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: background 0.2s;
}

.AIAgentBot_optionButton__p9QL3:hover {
  background: #5a67d8;
}

.AIAgentBot_checkoutContainer__zCyhm {
  margin-top: 16px;
}

/* New CSS classes for improved UI */
.AIAgentBot_creditsDisplay__hzWcL {
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.AIAgentBot_creditsMain__rA-XT {
  text-align: center;
  flex: 1 1;
}

.AIAgentBot_creditsRemaining__NZtUn {
  font-size: 2rem;
  font-weight: bold;
  color: #10b981;
  display: block;
}

.AIAgentBot_creditsUsed__yDE4V {
  font-size: 2rem;
  font-weight: bold;
  color: #6b7280;
  display: block;
}

.AIAgentBot_creditsTotal__CyMUR {
  font-size: 2rem;
  font-weight: bold;
  color: #3b82f6;
  display: block;
}

.AIAgentBot_creditsOverLimit__PT-Mr {
  font-size: 2rem;
  font-weight: bold;
  color: #ef4444;
  display: block;
}

.AIAgentBot_creditsLabel__6wiEP {
  font-size: 0.875rem;
  color: #6b7280;
  display: block;
  margin-top: 4px;
}

.AIAgentBot_creditsDivider__6Lnur {
  font-size: 1.5rem;
  color: #d1d5db;
}

.AIAgentBot_statsNote__ZVvO7 {
  background: #f0f9ff;
  padding: 12px;
  border-radius: 8px;
  font-size: 0.875rem;
  color: #0369a1;
  margin: 16px 0;
  border-left: 3px solid #0284c7;
}

.AIAgentBot_overLimitWarning__0tQZ5 {
  background: #fef3c7;
  padding: 12px;
  border-radius: 8px;
  font-size: 0.875rem;
  color: #92400e;
  margin: 16px 0;
  border-left: 3px solid #f59e0b;
}

.AIAgentBot_criticalWarning__wrYzT {
  background: #fee2e2;
  padding: 12px;
  border-radius: 8px;
  font-size: 0.875rem;
  color: #991b1b;
  margin: 16px 0;
  border-left: 3px solid #dc2626;
}

.AIAgentBot_progressOverLimit__yD87n {
  background: #ef4444;
}

.AIAgentBot_infoNote__cOpG8 {
  background: #e0e7ff;
  padding: 12px;
  border-radius: 8px;
  font-size: 0.875rem;
  color: #3730a3;
  margin-bottom: 20px;
}

/* Existing styles keep as is */
.AIAgentBot_aiMessageCreditsSection__52V0m {
  background: white;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* ... rest of your existing CSS remains ... */

/* Product Information Section Styles */
.AIAgentBot_productInfoSection__aLPIw {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 24px;
  border: 1px solid #e9ecef;
}

.AIAgentBot_productInfoSection__aLPIw h3 {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.AIAgentBot_productInfoHint__zU5si {
  font-size: 13px;
  color: #6c757d;
  margin: 0 0 16px 0;
}

.AIAgentBot_productInfoFields__PzIWn {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.AIAgentBot_productInfoField__zVESk {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.AIAgentBot_productInfoLabel__wVwDu {
  font-size: 14px;
  font-weight: 500;
  color: #495057;
}

.AIAgentBot_requiredStar__yZwm1 {
  color: #dc3545;
  margin-left: 2px;
}

.AIAgentBot_productInfoInput__q\\+x7V {
  padding: 10px 12px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 14px;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}

.AIAgentBot_productInfoInput__q\\+x7V:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
}

.AIAgentBot_productInfoTextarea__TUG0N {
  padding: 10px 12px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}

.AIAgentBot_productInfoTextarea__TUG0N:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
}

.AIAgentBot_fieldHint__P7m4Q {
  font-size: 12px;
  color: #6c757d;
  margin-top: 4px;
}

.AIAgentBot_modalLabel__C2XA3 {
  display: block;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 5px;
  color: #333;
}

.AIAgentBot_productSummaryTextarea__lwafD {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  transition: border-color 0.2s;
}

.AIAgentBot_productSummaryTextarea__lwafD:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
}

.AIAgentBot_disabledSection__sNr-f {
  opacity: 0.6;
  cursor: not-allowed;
}

.AIAgentBot_comingSoonTag__R3E7L {
  display: inline-block;
  margin-left: 8px;
  padding: 2px 6px;
  background-color: #ff9800;
  color: white;
  font-size: 10px;
  font-weight: bold;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.AIAgentBot_checkboxLabel__Poofw.AIAgentBot_disabledSection__sNr-f .AIAgentBot_checkboxText__P7yZw {
  color: #999;
}

.AIAgentBot_checkboxLabel__Poofw.AIAgentBot_disabledSection__sNr-f .AIAgentBot_checkbox__qS5Ag {
  cursor: not-allowed;
}

.AIAgentBot_aiMessageCreditsSection__52V0m {
  margin-top: 20px;
  margin-bottom: 30px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
  border: 1px solid #e9ecef;
}

.AIAgentBot_creditsContainer__8z2E\\+ {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.AIAgentBot_creditsDisplay__hzWcL {
  text-align: center;
  margin-bottom: 10px;
}

.AIAgentBot_creditsRemaining__NZtUn {
  font-size: 36px;
  font-weight: bold;
  color: var(--saveBtn);
}

.AIAgentBot_creditsTotal__CyMUR {
  font-size: 24px;
  color: #6c757d;
  margin-left: 5px;
}

.AIAgentBot_creditsLabel__6wiEP {
  display: block;
  font-size: 14px;
  color: #6c757d;
  margin-top: 5px;
}

.AIAgentBot_progressBar__l6v29 {
  width: 100%;
  height: 8px;
  background-color: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
}

.AIAgentBot_progressFill__JPIB1 {
  height: 100%;
  background-color: var(--saveBtn);
  transition: width 0.3s ease;
  border-radius: 4px;
}

.AIAgentBot_topUpSection__oEkTP {
  margin-top: 15px;
  text-align: center;
  padding: 15px;
  background: #fff3cd;
  border-radius: 8px;
  border: 1px solid #ffc107;
}

.AIAgentBot_topUpButton__m338V {
  background-color: #ffc107;
  color: #212529;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.AIAgentBot_topUpButton__m338V:hover {
  background-color: #e0a800;
  transform: translateY(-1px);
}

.AIAgentBot_topUpInfo__4\\+8wB {
  font-size: 12px;
  color: #856404;
  margin-top: 8px;
}

.AIAgentBot_lowCreditsWarning__sOJRv {
  margin-top: 10px;
  padding: 10px;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 6px;
  color: #721c24;
  font-size: 13px;
  text-align: center;
}

/* Add to AIAgentBot.module.css */
.AIAgentBot_exploreClickablesCheckbox__ix-nS {
  display: flex;
  align-items: center;
  margin-left: 8px;
}

.AIAgentBot_exploreClickablesLabel__9AEGG {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 12px;
  color: #666;
}

.AIAgentBot_exploreClickablesText__u7E\\+t {
  margin-left: 4px;
  white-space: nowrap;
}

/* Make sure the URL input row can accommodate the new checkbox */
.AIAgentBot_urlInputRow__qGbnP {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.AIAgentBot_urlInputWithStatus__Po-cU {
  flex: 1 1;
  min-width: 250px;
  position: relative;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .AIAgentBot_urlInputRow__qGbnP {
    flex-direction: column;
    align-items: stretch;
  }

  .AIAgentBot_exploreClickablesCheckbox__ix-nS {
    margin-left: 0;
    margin-top: 4px;
  }
}

/* Add these styles to your existing CSS module */

/* Add to AIAgentBot.module.css */
.AIAgentBot_dataIdsInfo__ik10G {
  margin-top: 15px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #f9f9f9;
}

.AIAgentBot_dataIdsHeader__mBD\\+8 {
  padding: 8px 0;
  border-bottom: 1px solid #eee;
}

.AIAgentBot_dataIdsHeader__mBD\\+8:hover {
  background-color: #f0f0f0;
  border-radius: 3px;
}

.AIAgentBot_dataIdsContent__12VK4 {
  padding-top: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.AIAgentBot_dataIdItem__4BotL {
  margin-bottom: 8px;
  padding: 6px 10px;
  background-color: white;
  border: 1px solid #eee;
  border-radius: 4px;
  font-size: 14px;
}

.AIAgentBot_dataIdItem__4BotL strong {
  display: inline-block;
  min-width: 120px;
  color: #555;
}

.AIAgentBot_upcomingLabel__Dc3QN {
  color: #8a6d3b;
  font-size: 0.75em;
  font-weight: 600;
  margin-left: 6px;
  background: #fcf8e3;
  padding: 3px 8px;
  border-radius: 10px;
  border: 1px dashed #faebcc;
  transform: rotate(-2deg) translateX(-30px) translateY(-30px);
  display: inline-block;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  font-style: italic;
}

.AIAgentBot_uploadedFileInfo__A1-Z3 {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-left: 10px;
}

.AIAgentBot_uploadedFileName__9EqMo {
  font-size: 12px;
  color: var(--saveBtn);
}

.AIAgentBot_originalFileName__ykkb1 {
  font-size: 11px;
  color: #6c757d;
  font-style: italic;
}

.AIAgentBot_reingestUploadSection__AAMcy {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin: 5px 0;
}

.AIAgentBot_uploadButtonDisabled__uNK53 {
  opacity: 0.5;
  cursor: not-allowed !important;
  background-color: #ccc !important;
}

.AIAgentBot_uploadedFileName__9EqMo {
  font-size: 12px;
  color: var(--saveBtn);
  margin-left: 10px;
}

.AIAgentBot_fileUploadError__M9h0s {
  color: #dc3545;
  font-size: 12px;
  margin-top: 5px;
  font-weight: bold;
}

/* Add red border when there's an upload error */
.AIAgentBot_fileItemError__zm7\\+w {
  border: 2px solid #dc3545 !important;
  border-radius: 4px;
  padding: 8px;
  margin: 5px 0;
}

.AIAgentBot_fileOptions__1K63- {
  display: flex;
  gap: 15px;
  margin: 8px 0;
}

.AIAgentBot_fileForceReingestCheckbox__tq4XC,
.AIAgentBot_fileForceDeleteCheckbox__Zejn8 {
  display: flex;
  align-items: center;
}

.AIAgentBot_fileForceReingestLabel__rZn52,
.AIAgentBot_fileForceDeleteLabel__iy4lk {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 12px;
  color: #666;
}

.AIAgentBot_fileForceReingestText__RY6P5,
.AIAgentBot_fileForceDeleteText__fdiph {
  font-size: 12px;
}

/* Training summary stats */
.AIAgentBot_statSkipped__c1o68,
.AIAgentBot_statDeleted__4ULSw {
  font-size: 12px;
  margin-right: 12px;
  padding: 2px 6px;
  border-radius: 4px;
}

.AIAgentBot_statSkipped__c1o68 {
  background-color: #fff3cd;
  color: #856404;
}

.AIAgentBot_statDeleted__4ULSw {
  background-color: #f8d7da;
  color: #721c24;
}

.AIAgentBot_previouslyFailedSection__xhdeT {
  margin-top: 15px;
  padding: 10px;
  background-color: #fff5f5;
  border: 1px solid #fed7d7;
  border-radius: 4px;
}

.AIAgentBot_failedUrlItem__fpxuV {
  display: flex;
  flex-direction: column;
  padding: 8px;
  margin-bottom: 5px;
  background-color: #fff;
  border: 1px solid #feb2b2;
  border-radius: 3px;
}

.AIAgentBot_failedUrlInfo__7PFAd {
  display: flex;
  flex-direction: column;
}

.AIAgentBot_failedUrl__HDZjm {
  font-weight: bold;
  color: #c53030;
  margin-bottom: 4px;
}

.AIAgentBot_failedMessage__h\\+XIi {
  color: #e53e3e;
  font-size: 12px;
}

/* Force Reingest Checkbox Styles */
.AIAgentBot_forceReingestCheckbox__8IprL {
  display: flex;
  align-items: center;
  margin-left: 10px;
}

.AIAgentBot_forceReingestLabel__94y3q {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 12px;
  color: #666;
}

.AIAgentBot_forceReingestText__L54JQ {
  margin-left: 5px;
}

/* URL Input Row Layout */
.AIAgentBot_urlInputRow__qGbnP {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.AIAgentBot_urlInputWithStatus__Po-cU {
  flex: 1 1;
  position: relative;
  display: flex;
  align-items: center;
}

/* Adjust URL input to accommodate checkbox */
.AIAgentBot_urlInput__W44tc {
  flex: 1 1;
  /* Your existing URL input styles */
}

.AIAgentBot_disabledDuringTraining__PrSfu {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Additional URLs Section */
.AIAgentBot_additionalUrlsSection__RPw2m {
  margin-top: 16px;
  padding: 12px;
  background-color: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.AIAgentBot_additionalUrlsSection__RPw2m h5 {
  margin: 0 0 8px 0;
  font-size: 14px;
  color: #495057;
}

.AIAgentBot_urlResultItem__\\+CWbq {
  margin-bottom: 8px;
  padding: 8px;
  border-radius: 4px;
}

.AIAgentBot_urlResultSuccess__wlDDg {
  color: #155724;
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
}

.AIAgentBot_urlResultFailed__sylkv {
  color: #721c24;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
}

.AIAgentBot_urlResultUrl__xPZSy {
  display: block;
  font-weight: 500;
  margin-bottom: 4px;
}

.AIAgentBot_urlResultStatus__iqWAW {
  display: block;
  font-size: 12px;
}

.AIAgentBot_urlResultDataIds__B3B7S {
  display: block;
  font-size: 12px;
  margin-top: 2px;
  font-family: monospace;
}

/* Updated Training Summary */
.AIAgentBot_trainingMessage__eFReG {
  margin-top: 8px;
  padding: 8px;
  background-color: #e7f3ff;
  border-radius: 4px;
  font-size: 14px;
}

.AIAgentBot_statLimit__ICXT- {
  font-size: 12px;
  color: #6c757d;
  margin-left: 12px;
}

/* Allow Nested Section */
.AIAgentBot_allowNestedSection__rQxnU {
  margin-bottom: 15px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e9ecef;
}

.AIAgentBot_allowNestedLabel__T5xmY {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 0;
}

.AIAgentBot_allowNestedText__2oqg3 {
  font-size: 0.9rem;
  color: #495057;
  font-weight: 500;
}

/* URL Input with Status */
.AIAgentBot_urlInputWithStatus__Po-cU {
  position: relative;
  flex: 1 1;
  display: flex;
  align-items: center;
}

.AIAgentBot_urlInput__W44tc {
  flex: 1 1;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.AIAgentBot_urlInput__W44tc:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.AIAgentBot_urlInputSuccess__t5AaI {
  border-color: var(--saveBtn) !important;
  background-color: #f8fff9 !important;
  box-shadow: 0 0 0 2px rgba(40, 167, 69, 0.25) !important;
}

.AIAgentBot_urlInputFailed__HXiSS {
  border-color: #dc3545 !important;
  background-color: #fff5f5 !important;
  box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.25) !important;
}

.AIAgentBot_urlInputError__9YrYf {
  border-color: #dc3545 !important;
  background-color: #fff5f5 !important;
  box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.25) !important;
}

/* URL Status Indicators */
.AIAgentBot_urlStatusSuccess__Kfq0e,
.AIAgentBot_urlStatusFailed__Ubm7O,
.AIAgentBot_urlStatusDefault__Jqm\\+m {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: bold;
}

.AIAgentBot_urlStatusSuccess__Kfq0e {
  background-color: var(--saveBtn);
  color: white;
}

.AIAgentBot_urlStatusFailed__Ubm7O {
  background-color: #dc3545;
  color: white;
}

.AIAgentBot_urlStatusDefault__Jqm\\+m {
  background-color: #6c757d;
  color: white;
}

/* URL Status Messages */
.AIAgentBot_urlStatusMessageSuccess__4F-J3,
.AIAgentBot_urlStatusMessageFailed__hD\\+4\\+,
.AIAgentBot_urlStatusMessageDefault__i4L9\\+ {
  margin-top: 5px;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 0.8rem;
  line-height: 1.3;
}

.AIAgentBot_urlStatusMessageSuccess__4F-J3 {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.AIAgentBot_urlStatusMessageFailed__hD\\+4\\+ {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.AIAgentBot_urlStatusMessageDefault__i4L9\\+ {
  background-color: #e2e3e5;
  color: #383d41;
  border: 1px solid #d6d8db;
}

.AIAgentBot_urlDataIds__0xYEh {
  margin-top: 3px;
  font-size: 0.75rem;
  opacity: 0.8;
}

/* Training Summary */
.AIAgentBot_trainingSummary__tsgV1 {
  margin-top: 15px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #dee2e6;
}

.AIAgentBot_trainingSummary__tsgV1 h5 {
  margin: 0 0 8px 0;
  color: #495057;
  font-size: 0.9rem;
}

.AIAgentBot_trainingStats__U08\\+0 {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}

.AIAgentBot_statSuccess__K6qV5,
.AIAgentBot_statFailed__rQhoH,
.AIAgentBot_statStorage__xZlTZ {
  font-size: 0.8rem;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 4px;
}

.AIAgentBot_statSuccess__K6qV5 {
  background-color: #d4edda;
  color: #155724;
}

.AIAgentBot_statFailed__rQhoH {
  background-color: #f8d7da;
  color: #721c24;
}

.AIAgentBot_statStorage__xZlTZ {
  background-color: #cce7ff;
  color: #004085;
}

.AIAgentBot_stoppedReason__9s2eu {
  margin-top: 8px;
  padding: 6px 10px;
  background-color: #fff3cd;
  color: #856404;
  border-radius: 4px;
  font-size: 0.8rem;
  border: 1px solid #ffeaa7;
}

/* URLs Section Error Styles */
.AIAgentBot_urlSectionError__Xvw12 {
  border: 2px solid #dc3545 !important;
  background-color: #fff5f5 !important;
}

.AIAgentBot_urlSectionErrorText__HQvd1 {
  color: #dc3545;
  font-size: 0.9rem;
  margin-top: 10px;
  padding: 8px;
  background-color: #ffe6e6;
  border-radius: 4px;
  border-left: 4px solid #dc3545;
}

.AIAgentBot_urlInputContainer__8D3Xg {
  margin-bottom: 10px;
}

.AIAgentBot_urlError__Oc5Ia {
  color: #dc3545;
  font-size: 0.8rem;
  margin-top: 4px;
  padding-left: 4px;
}

/* Rest of your existing styles remain the same... */

/* Action Buttons */
.AIAgentBot_actionButtons__yDqzj {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #ddd;
}

.AIAgentBot_cancelButton__w4A3I {
  padding: 8px 16px;
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.AIAgentBot_cancelButton__w4A3I:disabled {
  background-color: #a0a0a0;
  cursor: not-allowed;
}

.AIAgentBot_cancelButton__w4A3I:hover:not(:disabled) {
  background-color: #5a6268;
}

.AIAgentBot_submitButton__zvfJv {
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.AIAgentBot_submitButton__zvfJv:disabled {
  background-color: #a0a0a0;
  cursor: not-allowed;
}

.AIAgentBot_submitButton__zvfJv:hover:not(:disabled) {
  background-color: var(--editHover);
}

.AIAgentBot_retrainButton__lf2uz {
  padding: 8px 16px;
  background-color: var(--saveBtn);
  color: var(--white-color);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.AIAgentBot_retrainButton__lf2uz:disabled {
  background-color: #a0a0a0;
  cursor: not-allowed;
}

.AIAgentBot_retrainButton__lf2uz:hover:not(:disabled) {
  background-color: var(--saveHover);
  transform: translateY(-1px);
}

/* Training Status Messages */
.AIAgentBot_trainingSuccess__IJ97b {
  color: #155724;
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  border-radius: 4px;
  padding: 8px 12px;
  margin-top: 10px;
  font-size: 0.9rem;
}

.AIAgentBot_trainingError__RvF8L {
  color: #721c24;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
  padding: 8px 12px;
  margin-top: 10px;
  font-size: 0.9rem;
}

.AIAgentBot_trainingLoading__v1bzH {
  color: #856404;
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  padding: 8px 12px;
  margin-top: 10px;
  font-size: 0.9rem;
}

/* URLs Section Error Styles */
.AIAgentBot_urlSectionError__Xvw12 {
  border: 2px solid #dc3545 !important;
  background-color: #fff5f5 !important;
}

.AIAgentBot_urlSectionErrorText__HQvd1 {
  color: #dc3545;
  font-size: 0.9rem;
  margin-top: 10px;
  padding: 8px;
  background-color: #ffe6e6;
  border-radius: 4px;
  border-left: 4px solid #dc3545;
}

.AIAgentBot_urlInputContainer__8D3Xg {
  margin-bottom: 10px;
}

.AIAgentBot_urlInputError__9YrYf {
  border-color: #dc3545 !important;
  background-color: #fff5f5 !important;
  box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.25) !important;
}

.AIAgentBot_urlError__Oc5Ia {
  color: #dc3545;
  font-size: 0.8rem;
  margin-top: 4px;
  padding-left: 4px;
}

/* Rest of your existing styles remain the same... */

/* AI Chat Styles */
.AIAgentBot_aiAgentSection__wxS8b {
  margin-bottom: 30px;
  padding: 15px;
  background: #e6edff;
  border-radius: 6px;
  border: 1px solid #a3bdff;
}

.AIAgentBot_aiAgentSection__wxS8b h3 {
  margin: 0 0 20px 0;
  color: var(--dark2-color);
  font-size: 1.2rem;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
}

.AIAgentBot_dataSourceSection__yLzA3 {
  margin-bottom: 20px;
  padding: 15px;
  background: white;
  border-radius: 6px;
  border: 1px solid #e8e8e8;
}

.AIAgentBot_dataSourceSection__yLzA3 h4 {
  margin: 0 0 15px 0;
  color: #555;
  font-size: 1rem;
}

.AIAgentBot_dataSourceSection__yLzA3 h5 {
  margin: 15px 0 10px 0;
  color: #666;
  font-size: 0.9rem;
}

/* File Upload Styles */
.AIAgentBot_uploadSection__5IWFr {
  margin-bottom: 15px;
}

.AIAgentBot_fileInput__v9Jox {
  display: none;
}

.AIAgentBot_uploadButton__-vlK2 {
  display: inline-block;
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
}

.AIAgentBot_uploadButton__-vlK2:hover {
  background-color: var(--editHover);
}

.AIAgentBot_fileList__ci8RQ {
  margin-top: 10px;
}

.AIAgentBot_fileItem__1jOFw {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  margin-bottom: 5px;
}

.AIAgentBot_fileName__2ePaP {
  font-weight: 500;
  color: #333;
}

/* URL Input Styles */
.AIAgentBot_urlInputs__6WlrO {
  margin-bottom: 10px;
}

.AIAgentBot_urlInputRow__qGbnP {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  gap: 8px;
}

.AIAgentBot_urlInput__W44tc {
  flex: 1 1;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.9rem;
}

.AIAgentBot_urlInput__W44tc:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

/* Button Styles */
.AIAgentBot_addButton__FnlpZ {
  padding: 6px 12px;
  background-color: var(--saveBtn);
  color: var(--white-color);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
}

.AIAgentBot_addButton__FnlpZ:hover {
  background-color: var(--saveHover);
}

.AIAgentBot_removeButton__PIzlT {
  padding: 4px 8px;
  background-color: var(--danger);
  color: var(--white-color);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
}

.AIAgentBot_removeButton__PIzlT:hover {
  background-color: var(--deleteHover);
}

/* Action Buttons */
.AIAgentBot_actionButtons__yDqzj {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #ddd;
}

.AIAgentBot_cancelButton__w4A3I {
  padding: 8px 16px;
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.AIAgentBot_cancelButton__w4A3I:disabled {
  background-color: #a0a0a0;
  cursor: not-allowed;
}

.AIAgentBot_cancelButton__w4A3I:hover:not(:disabled) {
  background-color: #5a6268;
}

.AIAgentBot_submitButton__zvfJv {
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.AIAgentBot_submitButton__zvfJv:disabled {
  background-color: #a0a0a0;
  cursor: not-allowed;
}

.AIAgentBot_submitButton__zvfJv:hover:not(:disabled) {
  background-color: var(--editHover);
}

/* Data IDs Info */
.AIAgentBot_dataIds__f0lTY {
  display: block;
  font-size: 0.8rem;
  color: #666;
  margin-top: 4px;
}

.AIAgentBot_dataIdsInfo__ik10G {
  margin-top: 15px;
  padding: 10px;
  background: #e7f3ff;
  border-radius: 4px;
  border: 1px solid #b3d9ff;
}

.AIAgentBot_dataIdItem__4BotL {
  margin: 5px 0;
  font-size: 0.9rem;
}

/* Checkbox Styles */
.AIAgentBot_checkboxLabel__Poofw {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 15px;
  font-weight: 600;
}

.AIAgentBot_checkbox__qS5Ag {
  margin-right: 10px;
  transform: scale(1.2);
}

.AIAgentBot_checkboxText__P7yZw {
  font-size: 1rem;
  color: #333;
}

/* File Section */
.AIAgentBot_fileSection__zw15k {
  margin-top: 10px;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

/* URL Section */
.AIAgentBot_urlSection__HSUG\\+ {
  margin-top: 10px;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

/* Sitemap Section */
.AIAgentBot_sitemapSection__YB3AG {
  margin-top: 10px;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

/* Toggle Switch Styles */
.AIAgentBot_toggleSection__C0g-G {
  margin-bottom: 20px;
  padding: 15px;
  background: white;
  border-radius: 6px;
  border: 1px solid #e8e8e8;
}

.AIAgentBot_toggleLabel__T3mQv {
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 12px;
  flex-direction: column;
  align-items: flex-start;
}

.AIAgentBot_toggleCheckbox__ONKiQ {
  display: none;
}
.AIAgentBot_titleSection__WMsGU {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-align: center;
  flex-direction: column;
}
.AIAgentBot_toggleSlider__OdNIg {
  position: relative;
  width: 50px;
  height: 24px;
  background-color: #ccc;
  border-radius: 24px;
  transition: background-color 0.3s;
  flex-shrink: 0;
}

.AIAgentBot_toggleSlider__OdNIg:before {
  content: "";
  position: absolute;
  width: 20px;
  height: 20px;
  left: 2px;
  top: 2px;
  background-color: var(--white-color);
  border-radius: 50%;
  transition: transform 0.3s;
}

.AIAgentBot_toggleCheckbox__ONKiQ:checked + .AIAgentBot_toggleSlider__OdNIg {
  background-color: #37a57f;
}

.AIAgentBot_toggleCheckbox__ONKiQ:checked + .AIAgentBot_toggleSlider__OdNIg:before {
  transform: translateX(26px);
}
.AIAgentBot_toggleControl__9wb4R {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  justify-content: flex-end;
  gap: 12px;
}
.AIAgentBot_toggleText__\\+i\\+Gd {
  font-size: 16px;
  font-weight: 600;
  color: #495057;
  display: block;
  margin-bottom: 10px;
}

/* Checkbox Styles */
.AIAgentBot_checkboxLabel__Poofw {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 15px;
  font-weight: 600;
}

.AIAgentBot_checkbox__qS5Ag {
  margin-right: 10px;
  transform: scale(1.2);
}

.AIAgentBot_checkboxText__P7yZw {
  font-size: 1rem;
  color: var(--dark2-color);
}

/* File Section */
.AIAgentBot_fileSection__zw15k {
  margin-top: 10px;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

/* URL Section */
.AIAgentBot_urlSection__HSUG\\+ {
  margin-top: 10px;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

/* Sitemap Section */
.AIAgentBot_sitemapSection__YB3AG {
  margin-top: 10px;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

/* URLs Section Error Styles */
.AIAgentBot_urlSectionError__Xvw12 {
  border: 2px solid #dc3545 !important;
  background-color: #fff5f5 !important;
}

.AIAgentBot_urlSectionErrorText__HQvd1 {
  color: #dc3545;
  font-size: 0.9rem;
  margin-top: 10px;
  padding: 8px;
  background-color: #ffe6e6;
  border-radius: 4px;
  border-left: 4px solid #dc3545;
}

.AIAgentBot_urlInputContainer__8D3Xg {
  margin-bottom: 10px;
}

.AIAgentBot_urlInputError__9YrYf {
  border-color: #dc3545 !important;
  background-color: #fff5f5 !important;
  box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.25) !important;
}

.AIAgentBot_urlError__Oc5Ia {
  color: #dc3545;
  font-size: 0.8rem;
  margin-top: 4px;
  padding-left: 4px;
}

/* URL Input Styles */
.AIAgentBot_urlInputs__6WlrO {
  margin-bottom: 10px;
}

.AIAgentBot_urlInputRow__qGbnP {
  display: flex;
  align-items: center;
  gap: 8px;
}

.AIAgentBot_urlInput__W44tc {
  flex: 1 1;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.AIAgentBot_urlInput__W44tc:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

/* Button Styles */
.AIAgentBot_addButton__FnlpZ {
  padding: 6px 12px;
  background-color: var(--saveBtn);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
}

.AIAgentBot_addButton__FnlpZ:hover {
  background-color: var(--saveHover);
}

.AIAgentBot_removeButton__PIzlT {
  padding: 4px 8px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
}

.AIAgentBot_removeButton__PIzlT:hover {
  background-color: var(--deleteHover);
}

/* Submit Button disabled state for invalid URLs */
.AIAgentBot_submitButton__zvfJv:disabled {
  background-color: #a0a0a0;
  cursor: not-allowed;
}

/* Rest of your existing styles remain the same... */

.AIAgentBot_countDisplay__Hz-d8 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding-bottom: 20px;
  color: var(--text-color);
}
.AIAgentBot_helperText__VVuvO {
  font-size: 13px;
  color: #6c757d;
  margin: 5px 0 0 0;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/Component/app_components/AIAgentBot.module.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oDAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,0BAA0B;AAC1B;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,8BAA8B;AAChC;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,oCAAoC;AACpC;;EAEE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;;IAGE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;;;IAGE,cAAc;EAChB;AACF;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iDAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,gCAAgC;AAChC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf;;wBAEsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,oDAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB;;wCAEsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA,8CAA8C;;AAE9C,uCAAuC;AACvC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf;;mBAEiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB;;mBAEiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA,iDAAiD;;AAEjD,iCAAiC;AACjC;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,4DAA4D;EAC5D,qBAAqB;EACrB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA,gDAAgD;AAChD;EACE,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;;EAEE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,SAAO;EACP,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;EACpC,wDAAwD;AAC1D;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,wDAAwD;AAC1D;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,wDAAwD;AAC1D;;AAEA,0BAA0B;AAC1B;;;EAGE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,wBAAwB;AACxB;;;EAGE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;;;EAGE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA,oDAAoD;;AAEpD,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,8BAA8B;AAC9B;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,wDAAwD;AAC1D;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA,oDAAoD;;AAEpD,mBAAmB;AACnB;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,gCAAgC;EAChC,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;AACA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,oCAAoC;EACpC,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,8BAA8B;AAC9B;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,wDAAwD;AAC1D;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,kDAAkD;AAClD;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,oDAAoD;;AAEpD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;EACpB,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["/* Status Icon Styles */\n.statusIcon {\n  margin-left: 8px;\n  font-size: 16px;\n  flex-shrink: 0;\n}\n\n.statusLoading {\n  color: #f59e0b;\n  animation: spin 1s linear infinite;\n}\n\n.statusSuccess {\n  color: #10b981;\n}\n\n.statusFailed {\n  color: #ef4444;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* URL Input with Status */\n.urlInputWithStatus {\n  flex: 1;\n  min-width: 200px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.urlInput {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n  transition: border-color 0.2s;\n}\n\n.urlInput:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);\n}\n\n/* File Info with Status */\n.fileInfo {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n}\n\n.fileName {\n  font-weight: 500;\n  color: #333;\n}\n\n.dataIds {\n  font-size: 0.8rem;\n  color: #666;\n  margin-left: 4px;\n}\n\n/* File Item */\n.fileItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  margin-bottom: 5px;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.fileOptions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n}\n\n/* Training Ready State */\n.trainingReady {\n  color: #0c5460;\n  background-color: #d1ecf1;\n  border: 1px solid #bee5eb;\n  border-radius: 4px;\n  padding: 8px 12px;\n  margin-top: 10px;\n  font-size: 0.9rem;\n}\n\n/* Info Tooltip Styles */\n.infoTooltipWrapper {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  margin-left: 4px;\n  cursor: help;\n}\n\n.infoIcon {\n  color: #6c757d;\n  font-size: 14px;\n  transition: color 0.2s ease;\n}\n\n.infoIcon:hover {\n  color: #007bff;\n}\n\n.infoTooltip {\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  background: #1f2937;\n  color: white;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 400;\n  white-space: nowrap;\n  max-width: 300px;\n  white-space: normal;\n  word-wrap: break-word;\n  z-index: 1000;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  text-align: left;\n  line-height: 1.4;\n}\n\n.infoTooltip::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 6px solid transparent;\n  border-top-color: #1f2937;\n}\n\n/* URL Section Layout Improvements */\n.crawlingOptionsSection {\n  margin-bottom: 16px;\n  padding: 12px 16px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border: 1px solid #e9ecef;\n}\n\n.crawlingOptionsTitle {\n  margin: 0 0 12px 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #495057;\n}\n\n.crawlingOptionsGrid {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.allowNestedSection {\n  padding: 8px 0;\n}\n\n.allowNestedLabel {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  margin: 0;\n}\n\n.allowNestedText {\n  font-size: 14px;\n  color: #495057;\n}\n\n.globalExploreClickablesSection {\n  padding: 8px 0;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.globalExploreClickablesLabel {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  margin: 0;\n}\n\n.globalExploreClickablesText {\n  font-size: 14px;\n  color: #495057;\n  font-weight: 500;\n}\n\n.exploreClickablesHint {\n  margin-top: 6px;\n  padding: 6px 10px;\n  background: #e7f3ff;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #0066cc;\n  border-left: 3px solid #007bff;\n}\n\n/* URL Input Row Improvements */\n.urlInputRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 0;\n}\n\n.urlInputWithStatus {\n  flex: 1;\n  min-width: 200px;\n  position: relative;\n}\n\n.urlInput {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n  transition: border-color 0.2s;\n}\n\n.urlInput:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);\n}\n\n/* Per URL Explore Clickables */\n.perUrlExploreCheckbox {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.perUrlExploreLabel {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n  font-size: 13px;\n  color: #495057;\n}\n\n.perUrlExploreText {\n  font-size: 13px;\n  color: #495057;\n}\n\n/* Force Reingest and Force Delete */\n.forceReingestCheckbox,\n.forceDeleteCheckbox {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.forceReingestLabel,\n.forceDeleteLabel {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n  font-size: 13px;\n  color: #495057;\n}\n\n.forceReingestText,\n.forceDeleteText {\n  font-size: 13px;\n  color: #495057;\n}\n\n/* Responsive adjustments */\n@media (max-width: 1200px) {\n  .urlInputRow {\n    flex-wrap: wrap;\n  }\n\n  .urlInputWithStatus {\n    min-width: 100%;\n    flex-basis: 100%;\n  }\n\n  .perUrlExploreCheckbox,\n  .forceReingestCheckbox,\n  .forceDeleteCheckbox {\n    flex-shrink: 1;\n  }\n}\n\n@media (max-width: 768px) {\n  .urlInputRow {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n  }\n\n  .perUrlExploreCheckbox,\n  .forceReingestCheckbox,\n  .forceDeleteCheckbox {\n    margin-left: 0;\n  }\n}\n\n/* Add to AIAgentBot.module.css */\n.limitsDropdownSection {\n  margin-bottom: 10px;\n}\n\n.limitsDropdownHeader {\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.limitsDropdownHeader:hover {\n  background-color: #e9ecef !important;\n}\n\n.limitsDropdownContent {\n  animation: slideDown 0.3s ease;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Main credit section styling */\n.creditSection {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  margin-bottom: 24px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  transition: box-shadow 0.3s ease;\n}\n\n.creditSection:hover {\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.creditSection h3 {\n  margin: 0 0 20px 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.creditsContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.creditsMain {\n  text-align: center;\n  padding: 16px;\n  background: linear-gradient(135deg, #f3f4f6 0%, #ffffff 100%);\n  border-radius: 12px;\n}\n\n.creditsRemaining {\n  font-size: 3rem;\n  font-weight: bold;\n  color: #10b981;\n  display: block;\n  line-height: 1.2;\n}\n\n.creditsLabel {\n  font-size: 0.875rem;\n  color: #6b7280;\n  display: block;\n  margin-top: 8px;\n}\n\n.progressBar {\n  width: 100%;\n  height: 8px;\n  background-color: #e5e7eb;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.progressFill {\n  height: 100%;\n  background: linear-gradient(90deg, #10b981, #34d399);\n  border-radius: 4px;\n  transition: width 0.3s ease;\n}\n\n.capacityInfo {\n  background: #f9fafb;\n  padding: 12px;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n}\n\n.capacityRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 0;\n  font-size: 0.875rem;\n}\n\n.capacityRow span {\n  color: #6b7280;\n}\n\n.capacityRow strong {\n  color: #1f2937;\n  font-weight: 600;\n}\n\n.topupHighlight {\n  color: #8b5cf6 !important;\n}\n\n.statsNote {\n  background: #eff6ff;\n  padding: 12px;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  color: #1e40af;\n  border-left: 3px solid #3b82f6;\n  line-height: 1.5;\n}\n\n.topUpSection {\n  margin-top: 8px;\n  text-align: center;\n}\n\n.topUpButton {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition:\n    transform 0.2s ease,\n    box-shadow 0.2s ease;\n}\n\n.topUpButton:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.topUpInfo {\n  margin-top: 8px;\n  font-size: 0.75rem;\n  color: #6b7280;\n}\n\n.lowCreditsWarning {\n  background: #fef3c7;\n  padding: 12px;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  color: #92400e;\n  border-left: 3px solid #f59e0b;\n}\n\n.criticalWarning {\n  background: #fee2e2;\n  padding: 12px;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  color: #991b1b;\n  border-left: 3px solid #dc2626;\n}\n\n.loadingState {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  gap: 12px;\n}\n\n.loadingSpinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #f3f4f6;\n  border-top: 3px solid #667eea;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Modal Styles */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modalContent {\n  background: white;\n  border-radius: 16px;\n  max-width: 600px;\n  width: 90%;\n  max-height: 85vh;\n  overflow-y: auto;\n  box-shadow:\n    0 20px 25px -5px rgba(0, 0, 0, 0.1),\n    0 10px 10px -5px rgba(0, 0, 0, 0.04);\n}\n\n.modalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.modalHeader h3 {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.modalClose {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: #6b7280;\n  transition: color 0.2s;\n}\n\n.modalClose:hover {\n  color: #1f2937;\n}\n\n.modalBody {\n  padding: 24px;\n}\n\n.infoNote {\n  background: #e0e7ff;\n  padding: 12px;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  color: #3730a3;\n  margin-bottom: 20px;\n  line-height: 1.6;\n}\n\n.topUpOptions {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.topUpOption {\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 16px;\n  text-align: center;\n  transition: all 0.2s ease;\n}\n\n.topUpOption:hover {\n  border-color: #667eea;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.optionPrice {\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: #1f2937;\n  margin-bottom: 8px;\n}\n\n.optionMessages {\n  font-size: 0.875rem;\n  color: #6b7280;\n  margin-bottom: 4px;\n}\n\n.optionPerMessage {\n  font-size: 0.75rem;\n  color: #10b981;\n  margin-bottom: 12px;\n}\n\n.optionButton {\n  background: #667eea;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: background 0.2s;\n}\n\n.optionButton:hover {\n  background: #5a67d8;\n}\n\n.checkoutContainer {\n  margin-top: 16px;\n}\n\n/* New CSS classes for improved UI */\n.creditsDisplay {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n  margin-bottom: 20px;\n}\n\n.creditsMain {\n  text-align: center;\n  flex: 1;\n}\n\n.creditsRemaining {\n  font-size: 2rem;\n  font-weight: bold;\n  color: #10b981;\n  display: block;\n}\n\n.creditsUsed {\n  font-size: 2rem;\n  font-weight: bold;\n  color: #6b7280;\n  display: block;\n}\n\n.creditsTotal {\n  font-size: 2rem;\n  font-weight: bold;\n  color: #3b82f6;\n  display: block;\n}\n\n.creditsOverLimit {\n  font-size: 2rem;\n  font-weight: bold;\n  color: #ef4444;\n  display: block;\n}\n\n.creditsLabel {\n  font-size: 0.875rem;\n  color: #6b7280;\n  display: block;\n  margin-top: 4px;\n}\n\n.creditsDivider {\n  font-size: 1.5rem;\n  color: #d1d5db;\n}\n\n.statsNote {\n  background: #f0f9ff;\n  padding: 12px;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  color: #0369a1;\n  margin: 16px 0;\n  border-left: 3px solid #0284c7;\n}\n\n.overLimitWarning {\n  background: #fef3c7;\n  padding: 12px;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  color: #92400e;\n  margin: 16px 0;\n  border-left: 3px solid #f59e0b;\n}\n\n.criticalWarning {\n  background: #fee2e2;\n  padding: 12px;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  color: #991b1b;\n  margin: 16px 0;\n  border-left: 3px solid #dc2626;\n}\n\n.progressOverLimit {\n  background: #ef4444;\n}\n\n.infoNote {\n  background: #e0e7ff;\n  padding: 12px;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  color: #3730a3;\n  margin-bottom: 20px;\n}\n\n/* Existing styles keep as is */\n.aiMessageCreditsSection {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  margin-bottom: 24px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n/* ... rest of your existing CSS remains ... */\n\n/* Product Information Section Styles */\n.productInfoSection {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 16px 20px;\n  margin-bottom: 24px;\n  border: 1px solid #e9ecef;\n}\n\n.productInfoSection h3 {\n  margin: 0 0 8px 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n}\n\n.productInfoHint {\n  font-size: 13px;\n  color: #6c757d;\n  margin: 0 0 16px 0;\n}\n\n.productInfoFields {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.productInfoField {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.productInfoLabel {\n  font-size: 14px;\n  font-weight: 500;\n  color: #495057;\n}\n\n.requiredStar {\n  color: #dc3545;\n  margin-left: 2px;\n}\n\n.productInfoInput {\n  padding: 10px 12px;\n  border: 1px solid #ced4da;\n  border-radius: 6px;\n  font-size: 14px;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n\n.productInfoInput:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);\n}\n\n.productInfoTextarea {\n  padding: 10px 12px;\n  border: 1px solid #ced4da;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: inherit;\n  resize: vertical;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n\n.productInfoTextarea:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);\n}\n\n.fieldHint {\n  font-size: 12px;\n  color: #6c757d;\n  margin-top: 4px;\n}\n\n.modalLabel {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 5px;\n  color: #333;\n}\n\n.productSummaryTextarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: inherit;\n  resize: vertical;\n  transition: border-color 0.2s;\n}\n\n.productSummaryTextarea:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);\n}\n\n.disabledSection {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.comingSoonTag {\n  display: inline-block;\n  margin-left: 8px;\n  padding: 2px 6px;\n  background-color: #ff9800;\n  color: white;\n  font-size: 10px;\n  font-weight: bold;\n  border-radius: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.checkboxLabel.disabledSection .checkboxText {\n  color: #999;\n}\n\n.checkboxLabel.disabledSection .checkbox {\n  cursor: not-allowed;\n}\n\n.aiMessageCreditsSection {\n  margin-top: 20px;\n  margin-bottom: 30px;\n  padding: 20px;\n  background: #f8f9fa;\n  border-radius: 12px;\n  border: 1px solid #e9ecef;\n}\n\n.creditsContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.creditsDisplay {\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n.creditsRemaining {\n  font-size: 36px;\n  font-weight: bold;\n  color: var(--saveBtn);\n}\n\n.creditsTotal {\n  font-size: 24px;\n  color: #6c757d;\n  margin-left: 5px;\n}\n\n.creditsLabel {\n  display: block;\n  font-size: 14px;\n  color: #6c757d;\n  margin-top: 5px;\n}\n\n.progressBar {\n  width: 100%;\n  height: 8px;\n  background-color: #e9ecef;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.progressFill {\n  height: 100%;\n  background-color: var(--saveBtn);\n  transition: width 0.3s ease;\n  border-radius: 4px;\n}\n\n.topUpSection {\n  margin-top: 15px;\n  text-align: center;\n  padding: 15px;\n  background: #fff3cd;\n  border-radius: 8px;\n  border: 1px solid #ffc107;\n}\n\n.topUpButton {\n  background-color: #ffc107;\n  color: #212529;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.topUpButton:hover {\n  background-color: #e0a800;\n  transform: translateY(-1px);\n}\n\n.topUpInfo {\n  font-size: 12px;\n  color: #856404;\n  margin-top: 8px;\n}\n\n.lowCreditsWarning {\n  margin-top: 10px;\n  padding: 10px;\n  background-color: #f8d7da;\n  border: 1px solid #f5c6cb;\n  border-radius: 6px;\n  color: #721c24;\n  font-size: 13px;\n  text-align: center;\n}\n\n/* Add to AIAgentBot.module.css */\n.exploreClickablesCheckbox {\n  display: flex;\n  align-items: center;\n  margin-left: 8px;\n}\n\n.exploreClickablesLabel {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  font-size: 12px;\n  color: #666;\n}\n\n.exploreClickablesText {\n  margin-left: 4px;\n  white-space: nowrap;\n}\n\n/* Make sure the URL input row can accommodate the new checkbox */\n.urlInputRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.urlInputWithStatus {\n  flex: 1;\n  min-width: 250px;\n  position: relative;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .urlInputRow {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .exploreClickablesCheckbox {\n    margin-left: 0;\n    margin-top: 4px;\n  }\n}\n\n/* Add these styles to your existing CSS module */\n\n/* Add to AIAgentBot.module.css */\n.dataIdsInfo {\n  margin-top: 15px;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  background-color: #f9f9f9;\n}\n\n.dataIdsHeader {\n  padding: 8px 0;\n  border-bottom: 1px solid #eee;\n}\n\n.dataIdsHeader:hover {\n  background-color: #f0f0f0;\n  border-radius: 3px;\n}\n\n.dataIdsContent {\n  padding-top: 10px;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.dataIdItem {\n  margin-bottom: 8px;\n  padding: 6px 10px;\n  background-color: white;\n  border: 1px solid #eee;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.dataIdItem strong {\n  display: inline-block;\n  min-width: 120px;\n  color: #555;\n}\n\n.upcomingLabel {\n  color: #8a6d3b;\n  font-size: 0.75em;\n  font-weight: 600;\n  margin-left: 6px;\n  background: #fcf8e3;\n  padding: 3px 8px;\n  border-radius: 10px;\n  border: 1px dashed #faebcc;\n  transform: rotate(-2deg) translateX(-30px) translateY(-30px);\n  display: inline-block;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n  font-style: italic;\n}\n\n.uploadedFileInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-left: 10px;\n}\n\n.uploadedFileName {\n  font-size: 12px;\n  color: var(--saveBtn);\n}\n\n.originalFileName {\n  font-size: 11px;\n  color: #6c757d;\n  font-style: italic;\n}\n\n.reingestUploadSection {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  margin: 5px 0;\n}\n\n.uploadButtonDisabled {\n  opacity: 0.5;\n  cursor: not-allowed !important;\n  background-color: #ccc !important;\n}\n\n.uploadedFileName {\n  font-size: 12px;\n  color: var(--saveBtn);\n  margin-left: 10px;\n}\n\n.fileUploadError {\n  color: #dc3545;\n  font-size: 12px;\n  margin-top: 5px;\n  font-weight: bold;\n}\n\n/* Add red border when there's an upload error */\n.fileItemError {\n  border: 2px solid #dc3545 !important;\n  border-radius: 4px;\n  padding: 8px;\n  margin: 5px 0;\n}\n\n.fileOptions {\n  display: flex;\n  gap: 15px;\n  margin: 8px 0;\n}\n\n.fileForceReingestCheckbox,\n.fileForceDeleteCheckbox {\n  display: flex;\n  align-items: center;\n}\n\n.fileForceReingestLabel,\n.fileForceDeleteLabel {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  font-size: 12px;\n  color: #666;\n}\n\n.fileForceReingestText,\n.fileForceDeleteText {\n  font-size: 12px;\n}\n\n/* Training summary stats */\n.statSkipped,\n.statDeleted {\n  font-size: 12px;\n  margin-right: 12px;\n  padding: 2px 6px;\n  border-radius: 4px;\n}\n\n.statSkipped {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n.statDeleted {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n.previouslyFailedSection {\n  margin-top: 15px;\n  padding: 10px;\n  background-color: #fff5f5;\n  border: 1px solid #fed7d7;\n  border-radius: 4px;\n}\n\n.failedUrlItem {\n  display: flex;\n  flex-direction: column;\n  padding: 8px;\n  margin-bottom: 5px;\n  background-color: #fff;\n  border: 1px solid #feb2b2;\n  border-radius: 3px;\n}\n\n.failedUrlInfo {\n  display: flex;\n  flex-direction: column;\n}\n\n.failedUrl {\n  font-weight: bold;\n  color: #c53030;\n  margin-bottom: 4px;\n}\n\n.failedMessage {\n  color: #e53e3e;\n  font-size: 12px;\n}\n\n/* Force Reingest Checkbox Styles */\n.forceReingestCheckbox {\n  display: flex;\n  align-items: center;\n  margin-left: 10px;\n}\n\n.forceReingestLabel {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  font-size: 12px;\n  color: #666;\n}\n\n.forceReingestText {\n  margin-left: 5px;\n}\n\n/* URL Input Row Layout */\n.urlInputRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n}\n\n.urlInputWithStatus {\n  flex: 1;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n/* Adjust URL input to accommodate checkbox */\n.urlInput {\n  flex: 1;\n  /* Your existing URL input styles */\n}\n\n.disabledDuringTraining {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Additional URLs Section */\n.additionalUrlsSection {\n  margin-top: 16px;\n  padding: 12px;\n  background-color: #f8f9fa;\n  border-radius: 6px;\n  border: 1px solid #e9ecef;\n}\n\n.additionalUrlsSection h5 {\n  margin: 0 0 8px 0;\n  font-size: 14px;\n  color: #495057;\n}\n\n.urlResultItem {\n  margin-bottom: 8px;\n  padding: 8px;\n  border-radius: 4px;\n}\n\n.urlResultSuccess {\n  color: #155724;\n  background-color: #d4edda;\n  border: 1px solid #c3e6cb;\n}\n\n.urlResultFailed {\n  color: #721c24;\n  background-color: #f8d7da;\n  border: 1px solid #f5c6cb;\n}\n\n.urlResultUrl {\n  display: block;\n  font-weight: 500;\n  margin-bottom: 4px;\n}\n\n.urlResultStatus {\n  display: block;\n  font-size: 12px;\n}\n\n.urlResultDataIds {\n  display: block;\n  font-size: 12px;\n  margin-top: 2px;\n  font-family: monospace;\n}\n\n/* Updated Training Summary */\n.trainingMessage {\n  margin-top: 8px;\n  padding: 8px;\n  background-color: #e7f3ff;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.statLimit {\n  font-size: 12px;\n  color: #6c757d;\n  margin-left: 12px;\n}\n\n/* Allow Nested Section */\n.allowNestedSection {\n  margin-bottom: 15px;\n  padding: 10px;\n  background: #f8f9fa;\n  border-radius: 4px;\n  border: 1px solid #e9ecef;\n}\n\n.allowNestedLabel {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  margin: 0;\n}\n\n.allowNestedText {\n  font-size: 0.9rem;\n  color: #495057;\n  font-weight: 500;\n}\n\n/* URL Input with Status */\n.urlInputWithStatus {\n  position: relative;\n  flex: 1;\n  display: flex;\n  align-items: center;\n}\n\n.urlInput {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n}\n\n.urlInput:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.urlInputSuccess {\n  border-color: var(--saveBtn) !important;\n  background-color: #f8fff9 !important;\n  box-shadow: 0 0 0 2px rgba(40, 167, 69, 0.25) !important;\n}\n\n.urlInputFailed {\n  border-color: #dc3545 !important;\n  background-color: #fff5f5 !important;\n  box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.25) !important;\n}\n\n.urlInputError {\n  border-color: #dc3545 !important;\n  background-color: #fff5f5 !important;\n  box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.25) !important;\n}\n\n/* URL Status Indicators */\n.urlStatusSuccess,\n.urlStatusFailed,\n.urlStatusDefault {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8rem;\n  font-weight: bold;\n}\n\n.urlStatusSuccess {\n  background-color: var(--saveBtn);\n  color: white;\n}\n\n.urlStatusFailed {\n  background-color: #dc3545;\n  color: white;\n}\n\n.urlStatusDefault {\n  background-color: #6c757d;\n  color: white;\n}\n\n/* URL Status Messages */\n.urlStatusMessageSuccess,\n.urlStatusMessageFailed,\n.urlStatusMessageDefault {\n  margin-top: 5px;\n  padding: 6px 10px;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  line-height: 1.3;\n}\n\n.urlStatusMessageSuccess {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.urlStatusMessageFailed {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.urlStatusMessageDefault {\n  background-color: #e2e3e5;\n  color: #383d41;\n  border: 1px solid #d6d8db;\n}\n\n.urlDataIds {\n  margin-top: 3px;\n  font-size: 0.75rem;\n  opacity: 0.8;\n}\n\n/* Training Summary */\n.trainingSummary {\n  margin-top: 15px;\n  padding: 12px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border: 1px solid #dee2e6;\n}\n\n.trainingSummary h5 {\n  margin: 0 0 8px 0;\n  color: #495057;\n  font-size: 0.9rem;\n}\n\n.trainingStats {\n  display: flex;\n  gap: 15px;\n  flex-wrap: wrap;\n}\n\n.statSuccess,\n.statFailed,\n.statStorage {\n  font-size: 0.8rem;\n  font-weight: 500;\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n\n.statSuccess {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.statFailed {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n.statStorage {\n  background-color: #cce7ff;\n  color: #004085;\n}\n\n.stoppedReason {\n  margin-top: 8px;\n  padding: 6px 10px;\n  background-color: #fff3cd;\n  color: #856404;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  border: 1px solid #ffeaa7;\n}\n\n/* URLs Section Error Styles */\n.urlSectionError {\n  border: 2px solid #dc3545 !important;\n  background-color: #fff5f5 !important;\n}\n\n.urlSectionErrorText {\n  color: #dc3545;\n  font-size: 0.9rem;\n  margin-top: 10px;\n  padding: 8px;\n  background-color: #ffe6e6;\n  border-radius: 4px;\n  border-left: 4px solid #dc3545;\n}\n\n.urlInputContainer {\n  margin-bottom: 10px;\n}\n\n.urlError {\n  color: #dc3545;\n  font-size: 0.8rem;\n  margin-top: 4px;\n  padding-left: 4px;\n}\n\n/* Rest of your existing styles remain the same... */\n\n/* Action Buttons */\n.actionButtons {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  margin-top: 20px;\n  padding-top: 15px;\n  border-top: 1px solid #ddd;\n}\n\n.cancelButton {\n  padding: 8px 16px;\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.cancelButton:disabled {\n  background-color: #a0a0a0;\n  cursor: not-allowed;\n}\n\n.cancelButton:hover:not(:disabled) {\n  background-color: #5a6268;\n}\n\n.submitButton {\n  padding: 8px 16px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.submitButton:disabled {\n  background-color: #a0a0a0;\n  cursor: not-allowed;\n}\n\n.submitButton:hover:not(:disabled) {\n  background-color: var(--editHover);\n}\n\n.retrainButton {\n  padding: 8px 16px;\n  background-color: var(--saveBtn);\n  color: var(--white-color);\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.retrainButton:disabled {\n  background-color: #a0a0a0;\n  cursor: not-allowed;\n}\n\n.retrainButton:hover:not(:disabled) {\n  background-color: var(--saveHover);\n  transform: translateY(-1px);\n}\n\n/* Training Status Messages */\n.trainingSuccess {\n  color: #155724;\n  background-color: #d4edda;\n  border: 1px solid #c3e6cb;\n  border-radius: 4px;\n  padding: 8px 12px;\n  margin-top: 10px;\n  font-size: 0.9rem;\n}\n\n.trainingError {\n  color: #721c24;\n  background-color: #f8d7da;\n  border: 1px solid #f5c6cb;\n  border-radius: 4px;\n  padding: 8px 12px;\n  margin-top: 10px;\n  font-size: 0.9rem;\n}\n\n.trainingLoading {\n  color: #856404;\n  background-color: #fff3cd;\n  border: 1px solid #ffeaa7;\n  border-radius: 4px;\n  padding: 8px 12px;\n  margin-top: 10px;\n  font-size: 0.9rem;\n}\n\n/* URLs Section Error Styles */\n.urlSectionError {\n  border: 2px solid #dc3545 !important;\n  background-color: #fff5f5 !important;\n}\n\n.urlSectionErrorText {\n  color: #dc3545;\n  font-size: 0.9rem;\n  margin-top: 10px;\n  padding: 8px;\n  background-color: #ffe6e6;\n  border-radius: 4px;\n  border-left: 4px solid #dc3545;\n}\n\n.urlInputContainer {\n  margin-bottom: 10px;\n}\n\n.urlInputError {\n  border-color: #dc3545 !important;\n  background-color: #fff5f5 !important;\n  box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.25) !important;\n}\n\n.urlError {\n  color: #dc3545;\n  font-size: 0.8rem;\n  margin-top: 4px;\n  padding-left: 4px;\n}\n\n/* Rest of your existing styles remain the same... */\n\n/* AI Chat Styles */\n.aiAgentSection {\n  margin-bottom: 30px;\n  padding: 15px;\n  background: #e6edff;\n  border-radius: 6px;\n  border: 1px solid #a3bdff;\n}\n\n.aiAgentSection h3 {\n  margin: 0 0 20px 0;\n  color: var(--dark2-color);\n  font-size: 1.2rem;\n  border-bottom: 1px solid #ddd;\n  padding-bottom: 10px;\n}\n\n.dataSourceSection {\n  margin-bottom: 20px;\n  padding: 15px;\n  background: white;\n  border-radius: 6px;\n  border: 1px solid #e8e8e8;\n}\n\n.dataSourceSection h4 {\n  margin: 0 0 15px 0;\n  color: #555;\n  font-size: 1rem;\n}\n\n.dataSourceSection h5 {\n  margin: 15px 0 10px 0;\n  color: #666;\n  font-size: 0.9rem;\n}\n\n/* File Upload Styles */\n.uploadSection {\n  margin-bottom: 15px;\n}\n\n.fileInput {\n  display: none;\n}\n\n.uploadButton {\n  display: inline-block;\n  padding: 8px 16px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n}\n\n.uploadButton:hover {\n  background-color: var(--editHover);\n}\n\n.fileList {\n  margin-top: 10px;\n}\n\n.fileItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  margin-bottom: 5px;\n}\n\n.fileName {\n  font-weight: 500;\n  color: #333;\n}\n\n/* URL Input Styles */\n.urlInputs {\n  margin-bottom: 10px;\n}\n\n.urlInputRow {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n  gap: 8px;\n}\n\n.urlInput {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 0.9rem;\n}\n\n.urlInput:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n/* Button Styles */\n.addButton {\n  padding: 6px 12px;\n  background-color: var(--saveBtn);\n  color: var(--white-color);\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.8rem;\n}\n\n.addButton:hover {\n  background-color: var(--saveHover);\n}\n\n.removeButton {\n  padding: 4px 8px;\n  background-color: var(--danger);\n  color: var(--white-color);\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.8rem;\n}\n\n.removeButton:hover {\n  background-color: var(--deleteHover);\n}\n\n/* Action Buttons */\n.actionButtons {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  margin-top: 20px;\n  padding-top: 15px;\n  border-top: 1px solid #ddd;\n}\n\n.cancelButton {\n  padding: 8px 16px;\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.cancelButton:disabled {\n  background-color: #a0a0a0;\n  cursor: not-allowed;\n}\n\n.cancelButton:hover:not(:disabled) {\n  background-color: #5a6268;\n}\n\n.submitButton {\n  padding: 8px 16px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.submitButton:disabled {\n  background-color: #a0a0a0;\n  cursor: not-allowed;\n}\n\n.submitButton:hover:not(:disabled) {\n  background-color: var(--editHover);\n}\n\n/* Data IDs Info */\n.dataIds {\n  display: block;\n  font-size: 0.8rem;\n  color: #666;\n  margin-top: 4px;\n}\n\n.dataIdsInfo {\n  margin-top: 15px;\n  padding: 10px;\n  background: #e7f3ff;\n  border-radius: 4px;\n  border: 1px solid #b3d9ff;\n}\n\n.dataIdItem {\n  margin: 5px 0;\n  font-size: 0.9rem;\n}\n\n/* Checkbox Styles */\n.checkboxLabel {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  margin-bottom: 15px;\n  font-weight: 600;\n}\n\n.checkbox {\n  margin-right: 10px;\n  transform: scale(1.2);\n}\n\n.checkboxText {\n  font-size: 1rem;\n  color: #333;\n}\n\n/* File Section */\n.fileSection {\n  margin-top: 10px;\n  padding-top: 15px;\n  border-top: 1px solid #eee;\n}\n\n/* URL Section */\n.urlSection {\n  margin-top: 10px;\n  padding-top: 15px;\n  border-top: 1px solid #eee;\n}\n\n/* Sitemap Section */\n.sitemapSection {\n  margin-top: 10px;\n  padding-top: 15px;\n  border-top: 1px solid #eee;\n}\n\n/* Toggle Switch Styles */\n.toggleSection {\n  margin-bottom: 20px;\n  padding: 15px;\n  background: white;\n  border-radius: 6px;\n  border: 1px solid #e8e8e8;\n}\n\n.toggleLabel {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  gap: 12px;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.toggleCheckbox {\n  display: none;\n}\n.titleSection {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  text-align: center;\n  flex-direction: column;\n}\n.toggleSlider {\n  position: relative;\n  width: 50px;\n  height: 24px;\n  background-color: #ccc;\n  border-radius: 24px;\n  transition: background-color 0.3s;\n  flex-shrink: 0;\n}\n\n.toggleSlider:before {\n  content: \"\";\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  left: 2px;\n  top: 2px;\n  background-color: var(--white-color);\n  border-radius: 50%;\n  transition: transform 0.3s;\n}\n\n.toggleCheckbox:checked + .toggleSlider {\n  background-color: #37a57f;\n}\n\n.toggleCheckbox:checked + .toggleSlider:before {\n  transform: translateX(26px);\n}\n.toggleControl {\n  display: flex;\n  align-items: center;\n  position: relative;\n  width: 100%;\n  justify-content: flex-end;\n  gap: 12px;\n}\n.toggleText {\n  font-size: 16px;\n  font-weight: 600;\n  color: #495057;\n  display: block;\n  margin-bottom: 10px;\n}\n\n/* Checkbox Styles */\n.checkboxLabel {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  margin-bottom: 15px;\n  font-weight: 600;\n}\n\n.checkbox {\n  margin-right: 10px;\n  transform: scale(1.2);\n}\n\n.checkboxText {\n  font-size: 1rem;\n  color: var(--dark2-color);\n}\n\n/* File Section */\n.fileSection {\n  margin-top: 10px;\n  padding-top: 15px;\n  border-top: 1px solid #eee;\n}\n\n/* URL Section */\n.urlSection {\n  margin-top: 10px;\n  padding-top: 15px;\n  border-top: 1px solid #eee;\n}\n\n/* Sitemap Section */\n.sitemapSection {\n  margin-top: 10px;\n  padding-top: 15px;\n  border-top: 1px solid #eee;\n}\n\n/* URLs Section Error Styles */\n.urlSectionError {\n  border: 2px solid #dc3545 !important;\n  background-color: #fff5f5 !important;\n}\n\n.urlSectionErrorText {\n  color: #dc3545;\n  font-size: 0.9rem;\n  margin-top: 10px;\n  padding: 8px;\n  background-color: #ffe6e6;\n  border-radius: 4px;\n  border-left: 4px solid #dc3545;\n}\n\n.urlInputContainer {\n  margin-bottom: 10px;\n}\n\n.urlInputError {\n  border-color: #dc3545 !important;\n  background-color: #fff5f5 !important;\n  box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.25) !important;\n}\n\n.urlError {\n  color: #dc3545;\n  font-size: 0.8rem;\n  margin-top: 4px;\n  padding-left: 4px;\n}\n\n/* URL Input Styles */\n.urlInputs {\n  margin-bottom: 10px;\n}\n\n.urlInputRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.urlInput {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n}\n\n.urlInput:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n/* Button Styles */\n.addButton {\n  padding: 6px 12px;\n  background-color: var(--saveBtn);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.8rem;\n}\n\n.addButton:hover {\n  background-color: var(--saveHover);\n}\n\n.removeButton {\n  padding: 4px 8px;\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.8rem;\n}\n\n.removeButton:hover {\n  background-color: var(--deleteHover);\n}\n\n/* Submit Button disabled state for invalid URLs */\n.submitButton:disabled {\n  background-color: #a0a0a0;\n  cursor: not-allowed;\n}\n\n/* Rest of your existing styles remain the same... */\n\n.countDisplay {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding-bottom: 20px;\n  color: var(--text-color);\n}\n.helperText {\n  font-size: 13px;\n  color: #6c757d;\n  margin: 5px 0 0 0;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statusIcon": `AIAgentBot_statusIcon__39565`,
	"statusLoading": `AIAgentBot_statusLoading__WAmmt`,
	"spin": `AIAgentBot_spin__CjsFu`,
	"statusSuccess": `AIAgentBot_statusSuccess__4D6mB`,
	"statusFailed": `AIAgentBot_statusFailed__dB3cC`,
	"urlInputWithStatus": `AIAgentBot_urlInputWithStatus__Po-cU`,
	"urlInput": `AIAgentBot_urlInput__W44tc`,
	"fileInfo": `AIAgentBot_fileInfo__YwU+Q`,
	"fileName": `AIAgentBot_fileName__2ePaP`,
	"dataIds": `AIAgentBot_dataIds__f0lTY`,
	"fileItem": `AIAgentBot_fileItem__1jOFw`,
	"fileOptions": `AIAgentBot_fileOptions__1K63-`,
	"trainingReady": `AIAgentBot_trainingReady__kCxUO`,
	"infoTooltipWrapper": `AIAgentBot_infoTooltipWrapper__XnIH8`,
	"infoIcon": `AIAgentBot_infoIcon__nvrRF`,
	"infoTooltip": `AIAgentBot_infoTooltip__mJxca`,
	"crawlingOptionsSection": `AIAgentBot_crawlingOptionsSection__o5FFb`,
	"crawlingOptionsTitle": `AIAgentBot_crawlingOptionsTitle__rX5wt`,
	"crawlingOptionsGrid": `AIAgentBot_crawlingOptionsGrid__2WLvT`,
	"allowNestedSection": `AIAgentBot_allowNestedSection__rQxnU`,
	"allowNestedLabel": `AIAgentBot_allowNestedLabel__T5xmY`,
	"allowNestedText": `AIAgentBot_allowNestedText__2oqg3`,
	"globalExploreClickablesSection": `AIAgentBot_globalExploreClickablesSection__yJ7qM`,
	"globalExploreClickablesLabel": `AIAgentBot_globalExploreClickablesLabel__Y0UdC`,
	"globalExploreClickablesText": `AIAgentBot_globalExploreClickablesText__z6wOw`,
	"exploreClickablesHint": `AIAgentBot_exploreClickablesHint__z2NmO`,
	"urlInputRow": `AIAgentBot_urlInputRow__qGbnP`,
	"perUrlExploreCheckbox": `AIAgentBot_perUrlExploreCheckbox__nM1b-`,
	"perUrlExploreLabel": `AIAgentBot_perUrlExploreLabel__JMjK7`,
	"perUrlExploreText": `AIAgentBot_perUrlExploreText__nfbO7`,
	"forceReingestCheckbox": `AIAgentBot_forceReingestCheckbox__8IprL`,
	"forceDeleteCheckbox": `AIAgentBot_forceDeleteCheckbox__WH7Ll`,
	"forceReingestLabel": `AIAgentBot_forceReingestLabel__94y3q`,
	"forceDeleteLabel": `AIAgentBot_forceDeleteLabel__MGknf`,
	"forceReingestText": `AIAgentBot_forceReingestText__L54JQ`,
	"forceDeleteText": `AIAgentBot_forceDeleteText__dtE9X`,
	"limitsDropdownSection": `AIAgentBot_limitsDropdownSection__UKOdT`,
	"limitsDropdownHeader": `AIAgentBot_limitsDropdownHeader__UkevF`,
	"limitsDropdownContent": `AIAgentBot_limitsDropdownContent__ZaN3T`,
	"slideDown": `AIAgentBot_slideDown__E+Z8g`,
	"creditSection": `AIAgentBot_creditSection__uqCsH`,
	"creditsContainer": `AIAgentBot_creditsContainer__8z2E+`,
	"creditsMain": `AIAgentBot_creditsMain__rA-XT`,
	"creditsRemaining": `AIAgentBot_creditsRemaining__NZtUn`,
	"creditsLabel": `AIAgentBot_creditsLabel__6wiEP`,
	"progressBar": `AIAgentBot_progressBar__l6v29`,
	"progressFill": `AIAgentBot_progressFill__JPIB1`,
	"capacityInfo": `AIAgentBot_capacityInfo__qp1nY`,
	"capacityRow": `AIAgentBot_capacityRow__AsI04`,
	"topupHighlight": `AIAgentBot_topupHighlight__kuffv`,
	"statsNote": `AIAgentBot_statsNote__ZVvO7`,
	"topUpSection": `AIAgentBot_topUpSection__oEkTP`,
	"topUpButton": `AIAgentBot_topUpButton__m338V`,
	"topUpInfo": `AIAgentBot_topUpInfo__4+8wB`,
	"lowCreditsWarning": `AIAgentBot_lowCreditsWarning__sOJRv`,
	"criticalWarning": `AIAgentBot_criticalWarning__wrYzT`,
	"loadingState": `AIAgentBot_loadingState__cTxmX`,
	"loadingSpinner": `AIAgentBot_loadingSpinner__bMrSx`,
	"modalOverlay": `AIAgentBot_modalOverlay__BvwY0`,
	"modalContent": `AIAgentBot_modalContent__aPgqn`,
	"modalHeader": `AIAgentBot_modalHeader__Uj2Hy`,
	"modalClose": `AIAgentBot_modalClose__NGFyk`,
	"modalBody": `AIAgentBot_modalBody__Nj9Dn`,
	"infoNote": `AIAgentBot_infoNote__cOpG8`,
	"topUpOptions": `AIAgentBot_topUpOptions__2aoa3`,
	"topUpOption": `AIAgentBot_topUpOption__7vM1Y`,
	"optionPrice": `AIAgentBot_optionPrice__fsQM1`,
	"optionMessages": `AIAgentBot_optionMessages__OSzVM`,
	"optionPerMessage": `AIAgentBot_optionPerMessage__0pUrL`,
	"optionButton": `AIAgentBot_optionButton__p9QL3`,
	"checkoutContainer": `AIAgentBot_checkoutContainer__zCyhm`,
	"creditsDisplay": `AIAgentBot_creditsDisplay__hzWcL`,
	"creditsUsed": `AIAgentBot_creditsUsed__yDE4V`,
	"creditsTotal": `AIAgentBot_creditsTotal__CyMUR`,
	"creditsOverLimit": `AIAgentBot_creditsOverLimit__PT-Mr`,
	"creditsDivider": `AIAgentBot_creditsDivider__6Lnur`,
	"overLimitWarning": `AIAgentBot_overLimitWarning__0tQZ5`,
	"progressOverLimit": `AIAgentBot_progressOverLimit__yD87n`,
	"aiMessageCreditsSection": `AIAgentBot_aiMessageCreditsSection__52V0m`,
	"productInfoSection": `AIAgentBot_productInfoSection__aLPIw`,
	"productInfoHint": `AIAgentBot_productInfoHint__zU5si`,
	"productInfoFields": `AIAgentBot_productInfoFields__PzIWn`,
	"productInfoField": `AIAgentBot_productInfoField__zVESk`,
	"productInfoLabel": `AIAgentBot_productInfoLabel__wVwDu`,
	"requiredStar": `AIAgentBot_requiredStar__yZwm1`,
	"productInfoInput": `AIAgentBot_productInfoInput__q+x7V`,
	"productInfoTextarea": `AIAgentBot_productInfoTextarea__TUG0N`,
	"fieldHint": `AIAgentBot_fieldHint__P7m4Q`,
	"modalLabel": `AIAgentBot_modalLabel__C2XA3`,
	"productSummaryTextarea": `AIAgentBot_productSummaryTextarea__lwafD`,
	"disabledSection": `AIAgentBot_disabledSection__sNr-f`,
	"comingSoonTag": `AIAgentBot_comingSoonTag__R3E7L`,
	"checkboxLabel": `AIAgentBot_checkboxLabel__Poofw`,
	"checkboxText": `AIAgentBot_checkboxText__P7yZw`,
	"checkbox": `AIAgentBot_checkbox__qS5Ag`,
	"exploreClickablesCheckbox": `AIAgentBot_exploreClickablesCheckbox__ix-nS`,
	"exploreClickablesLabel": `AIAgentBot_exploreClickablesLabel__9AEGG`,
	"exploreClickablesText": `AIAgentBot_exploreClickablesText__u7E+t`,
	"dataIdsInfo": `AIAgentBot_dataIdsInfo__ik10G`,
	"dataIdsHeader": `AIAgentBot_dataIdsHeader__mBD+8`,
	"dataIdsContent": `AIAgentBot_dataIdsContent__12VK4`,
	"dataIdItem": `AIAgentBot_dataIdItem__4BotL`,
	"upcomingLabel": `AIAgentBot_upcomingLabel__Dc3QN`,
	"uploadedFileInfo": `AIAgentBot_uploadedFileInfo__A1-Z3`,
	"uploadedFileName": `AIAgentBot_uploadedFileName__9EqMo`,
	"originalFileName": `AIAgentBot_originalFileName__ykkb1`,
	"reingestUploadSection": `AIAgentBot_reingestUploadSection__AAMcy`,
	"uploadButtonDisabled": `AIAgentBot_uploadButtonDisabled__uNK53`,
	"fileUploadError": `AIAgentBot_fileUploadError__M9h0s`,
	"fileItemError": `AIAgentBot_fileItemError__zm7+w`,
	"fileForceReingestCheckbox": `AIAgentBot_fileForceReingestCheckbox__tq4XC`,
	"fileForceDeleteCheckbox": `AIAgentBot_fileForceDeleteCheckbox__Zejn8`,
	"fileForceReingestLabel": `AIAgentBot_fileForceReingestLabel__rZn52`,
	"fileForceDeleteLabel": `AIAgentBot_fileForceDeleteLabel__iy4lk`,
	"fileForceReingestText": `AIAgentBot_fileForceReingestText__RY6P5`,
	"fileForceDeleteText": `AIAgentBot_fileForceDeleteText__fdiph`,
	"statSkipped": `AIAgentBot_statSkipped__c1o68`,
	"statDeleted": `AIAgentBot_statDeleted__4ULSw`,
	"previouslyFailedSection": `AIAgentBot_previouslyFailedSection__xhdeT`,
	"failedUrlItem": `AIAgentBot_failedUrlItem__fpxuV`,
	"failedUrlInfo": `AIAgentBot_failedUrlInfo__7PFAd`,
	"failedUrl": `AIAgentBot_failedUrl__HDZjm`,
	"failedMessage": `AIAgentBot_failedMessage__h+XIi`,
	"disabledDuringTraining": `AIAgentBot_disabledDuringTraining__PrSfu`,
	"additionalUrlsSection": `AIAgentBot_additionalUrlsSection__RPw2m`,
	"urlResultItem": `AIAgentBot_urlResultItem__+CWbq`,
	"urlResultSuccess": `AIAgentBot_urlResultSuccess__wlDDg`,
	"urlResultFailed": `AIAgentBot_urlResultFailed__sylkv`,
	"urlResultUrl": `AIAgentBot_urlResultUrl__xPZSy`,
	"urlResultStatus": `AIAgentBot_urlResultStatus__iqWAW`,
	"urlResultDataIds": `AIAgentBot_urlResultDataIds__B3B7S`,
	"trainingMessage": `AIAgentBot_trainingMessage__eFReG`,
	"statLimit": `AIAgentBot_statLimit__ICXT-`,
	"urlInputSuccess": `AIAgentBot_urlInputSuccess__t5AaI`,
	"urlInputFailed": `AIAgentBot_urlInputFailed__HXiSS`,
	"urlInputError": `AIAgentBot_urlInputError__9YrYf`,
	"urlStatusSuccess": `AIAgentBot_urlStatusSuccess__Kfq0e`,
	"urlStatusFailed": `AIAgentBot_urlStatusFailed__Ubm7O`,
	"urlStatusDefault": `AIAgentBot_urlStatusDefault__Jqm+m`,
	"urlStatusMessageSuccess": `AIAgentBot_urlStatusMessageSuccess__4F-J3`,
	"urlStatusMessageFailed": `AIAgentBot_urlStatusMessageFailed__hD+4+`,
	"urlStatusMessageDefault": `AIAgentBot_urlStatusMessageDefault__i4L9+`,
	"urlDataIds": `AIAgentBot_urlDataIds__0xYEh`,
	"trainingSummary": `AIAgentBot_trainingSummary__tsgV1`,
	"trainingStats": `AIAgentBot_trainingStats__U08+0`,
	"statSuccess": `AIAgentBot_statSuccess__K6qV5`,
	"statFailed": `AIAgentBot_statFailed__rQhoH`,
	"statStorage": `AIAgentBot_statStorage__xZlTZ`,
	"stoppedReason": `AIAgentBot_stoppedReason__9s2eu`,
	"urlSectionError": `AIAgentBot_urlSectionError__Xvw12`,
	"urlSectionErrorText": `AIAgentBot_urlSectionErrorText__HQvd1`,
	"urlInputContainer": `AIAgentBot_urlInputContainer__8D3Xg`,
	"urlError": `AIAgentBot_urlError__Oc5Ia`,
	"actionButtons": `AIAgentBot_actionButtons__yDqzj`,
	"cancelButton": `AIAgentBot_cancelButton__w4A3I`,
	"submitButton": `AIAgentBot_submitButton__zvfJv`,
	"retrainButton": `AIAgentBot_retrainButton__lf2uz`,
	"trainingSuccess": `AIAgentBot_trainingSuccess__IJ97b`,
	"trainingError": `AIAgentBot_trainingError__RvF8L`,
	"trainingLoading": `AIAgentBot_trainingLoading__v1bzH`,
	"aiAgentSection": `AIAgentBot_aiAgentSection__wxS8b`,
	"dataSourceSection": `AIAgentBot_dataSourceSection__yLzA3`,
	"uploadSection": `AIAgentBot_uploadSection__5IWFr`,
	"fileInput": `AIAgentBot_fileInput__v9Jox`,
	"uploadButton": `AIAgentBot_uploadButton__-vlK2`,
	"fileList": `AIAgentBot_fileList__ci8RQ`,
	"urlInputs": `AIAgentBot_urlInputs__6WlrO`,
	"addButton": `AIAgentBot_addButton__FnlpZ`,
	"removeButton": `AIAgentBot_removeButton__PIzlT`,
	"fileSection": `AIAgentBot_fileSection__zw15k`,
	"urlSection": `AIAgentBot_urlSection__HSUG+`,
	"sitemapSection": `AIAgentBot_sitemapSection__YB3AG`,
	"toggleSection": `AIAgentBot_toggleSection__C0g-G`,
	"toggleLabel": `AIAgentBot_toggleLabel__T3mQv`,
	"toggleCheckbox": `AIAgentBot_toggleCheckbox__ONKiQ`,
	"titleSection": `AIAgentBot_titleSection__WMsGU`,
	"toggleSlider": `AIAgentBot_toggleSlider__OdNIg`,
	"toggleControl": `AIAgentBot_toggleControl__9wb4R`,
	"toggleText": `AIAgentBot_toggleText__+i+Gd`,
	"countDisplay": `AIAgentBot_countDisplay__Hz-d8`,
	"helperText": `AIAgentBot_helperText__VVuvO`
};
export default ___CSS_LOADER_EXPORT___;
